import React, { FC } from "react";
import { Tabs as MuiTabs } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTabs>;

const Tabs: FC<Props> = (props) => {
    return <MuiTabs {...props}/>
}

export default Tabs;